import axios from 'axios'
import router from '@/router'

import { mockData } from './mock'

export async function api({ method, point, data: body, params }) {
  try {
    if (process.env.VUE_APP_API_URL_MOCK == 'true') {
      return mockData[point];
    }

    const { data } = await axios({
      method: method || 'get',
      url: process.env.VUE_APP_API_URL + point,
      data: body,
      withCredentials: true,
      params,
      headers: {
      'Content-Type': 'application/json'
      }
    })

    return data
  } catch (err) {
    if (err.message.indexOf('401') !== -1) {
      router.push('/login')
    }

    throw err
  }
}
